import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _105fc8d4 = () => interopDefault(import('../pages/accessibilite.vue' /* webpackChunkName: "pages/accessibilite" */))
const _8cb75922 = () => interopDefault(import('../pages/bureau-etude-urbanisme.vue' /* webpackChunkName: "pages/bureau-etude-urbanisme" */))
const _4ac36ae2 = () => interopDefault(import('../pages/collectivites-territoriales.vue' /* webpackChunkName: "pages/collectivites-territoriales" */))
const _44bf1f6e = () => interopDefault(import('../pages/confidentialite.vue' /* webpackChunkName: "pages/confidentialite" */))
const _1e95aa7b = () => interopDefault(import('../pages/ddt-ddtm-dreal.vue' /* webpackChunkName: "pages/ddt-ddtm-dreal" */))
const _2822e858 = () => interopDefault(import('../pages/guide.vue' /* webpackChunkName: "pages/guide" */))
const _2a4ec5f0 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _758d1a46 = () => interopDefault(import('../pages/loi-climat-et-resilience.vue' /* webpackChunkName: "pages/loi-climat-et-resilience" */))
const _48e90612 = () => interopDefault(import('../pages/mentions-legales.vue' /* webpackChunkName: "pages/mentions-legales" */))
const _6f34e6be = () => interopDefault(import('../pages/stats/index.vue' /* webpackChunkName: "pages/stats/index" */))
const _12e8184d = () => interopDefault(import('../pages/validation.vue' /* webpackChunkName: "pages/validation" */))
const _49d0237c = () => interopDefault(import('../pages/dev/api.vue' /* webpackChunkName: "pages/dev/api" */))
const _09f64ae4 = () => interopDefault(import('../pages/login/collectivites/explain.vue' /* webpackChunkName: "pages/login/collectivites/explain" */))
const _6c077edb = () => interopDefault(import('../pages/login/collectivites/signin.vue' /* webpackChunkName: "pages/login/collectivites/signin" */))
const _fec4555e = () => interopDefault(import('../pages/login/collectivites/signup.vue' /* webpackChunkName: "pages/login/collectivites/signup" */))
const _4c9a4292 = () => interopDefault(import('../pages/login/ddt/explain.vue' /* webpackChunkName: "pages/login/ddt/explain" */))
const _55e30657 = () => interopDefault(import('../pages/login/ddt/signin.vue' /* webpackChunkName: "pages/login/ddt/signin" */))
const _6a795ccd = () => interopDefault(import('../pages/login/ddt/signup.vue' /* webpackChunkName: "pages/login/ddt/signup" */))
const _73c4fb2e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _601d246e = () => interopDefault(import('../pages/collectivites/_code_collectivite.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite" */))
const _0a068ce8 = () => interopDefault(import('../pages/collectivites/_code_collectivite/index.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/index" */))
const _1c9749a2 = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees" */))
const _13785da7 = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/data.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/data" */))
const _3fa7c2f6 = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/geoide.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/geoide" */))
const _6560458c = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/georisques.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/georisques" */))
const _4d894c3f = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/gpu.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/gpu" */))
const _7719e140 = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/inpn.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/inpn" */))
const _8f88b306 = () => interopDefault(import('../pages/collectivites/_code_collectivite/informations.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/informations" */))
const _31ec53ba = () => interopDefault(import('../pages/collectivites/_collectiviteId.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId" */))
const _9cd51b60 = () => interopDefault(import('../pages/collectivites/_collectiviteId/glossaire.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/glossaire" */))
const _001d473d = () => interopDefault(import('../pages/collectivites/_collectiviteId/pac.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/pac" */))
const _18f25af2 = () => interopDefault(import('../pages/collectivites/_collectiviteId/prescriptions/index.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/prescriptions/index" */))
const _241d8d3d = () => interopDefault(import('../pages/collectivites/_collectiviteId/ressources.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/ressources" */))
const _072a0616 = () => interopDefault(import('../pages/collectivites/_collectiviteId/prescriptions/add.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/prescriptions/add" */))
const _34fa2b33 = () => interopDefault(import('../pages/collectivites/_collectiviteId/prescriptions/signup.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/prescriptions/signup" */))
const _1a8bb0b7 = () => interopDefault(import('../pages/collectivites/_collectiviteId/procedures/add.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/procedures/add" */))
const _0f405e1f = () => interopDefault(import('../pages/ddt/_departement.vue' /* webpackChunkName: "pages/ddt/_departement" */))
const _b6a0dd3c = () => interopDefault(import('../pages/ddt/_departement/index.vue' /* webpackChunkName: "pages/ddt/_departement/index" */))
const _14d488fa = () => interopDefault(import('../pages/ddt/_departement/collectivites/index.vue' /* webpackChunkName: "pages/ddt/_departement/collectivites/index" */))
const _7257b4f9 = () => interopDefault(import('../pages/ddt/_departement/enquete.vue' /* webpackChunkName: "pages/ddt/_departement/enquete" */))
const _b428d1bc = () => interopDefault(import('../pages/ddt/_departement/pac.vue' /* webpackChunkName: "pages/ddt/_departement/pac" */))
const _2a9075ba = () => interopDefault(import('../pages/ddt/_departement/procedures/index.vue' /* webpackChunkName: "pages/ddt/_departement/procedures/index" */))
const _45218754 = () => interopDefault(import('../pages/ddt/_departement/procedures/choix-collectivite.vue' /* webpackChunkName: "pages/ddt/_departement/procedures/choix-collectivite" */))
const _7d1e2ebf = () => interopDefault(import('../pages/ddt/_departement/collectivites/_collectiviteId/commune.vue' /* webpackChunkName: "pages/ddt/_departement/collectivites/_collectiviteId/commune" */))
const _af1a2ffc = () => interopDefault(import('../pages/ddt/_departement/collectivites/_collectiviteId/epci.vue' /* webpackChunkName: "pages/ddt/_departement/collectivites/_collectiviteId/epci" */))
const _86c1fff8 = () => interopDefault(import('../pages/ddt/_departement/collectivites/_collectiviteId/procedure/add.vue' /* webpackChunkName: "pages/ddt/_departement/collectivites/_collectiviteId/procedure/add" */))
const _5a4ce086 = () => interopDefault(import('../pages/frise/_procedureId/index.vue' /* webpackChunkName: "pages/frise/_procedureId/index" */))
const _30f4910b = () => interopDefault(import('../pages/print/_projectId.vue' /* webpackChunkName: "pages/print/_projectId" */))
const _f47582b8 = () => interopDefault(import('../pages/trames/_githubRef.vue' /* webpackChunkName: "pages/trames/_githubRef" */))
const _ec9d1882 = () => interopDefault(import('../pages/documents/_githubRef/pac.vue' /* webpackChunkName: "pages/documents/_githubRef/pac" */))
const _17c987d5 = () => interopDefault(import('../pages/frise/_procedureId/add.vue' /* webpackChunkName: "pages/frise/_procedureId/add" */))
const _0cd03a85 = () => interopDefault(import('../pages/frise/_procedureId/invite.vue' /* webpackChunkName: "pages/frise/_procedureId/invite" */))
const _98793776 = () => interopDefault(import('../pages/frise/_procedureId/update.vue' /* webpackChunkName: "pages/frise/_procedureId/update" */))
const _16cad812 = () => interopDefault(import('../pages/frise/_procedureId/_eventId.vue' /* webpackChunkName: "pages/frise/_procedureId/_eventId" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/accessibilite",
    component: _105fc8d4,
    name: "accessibilite"
  }, {
    path: "/bureau-etude-urbanisme",
    component: _8cb75922,
    name: "bureau-etude-urbanisme"
  }, {
    path: "/collectivites-territoriales",
    component: _4ac36ae2,
    name: "collectivites-territoriales"
  }, {
    path: "/confidentialite",
    component: _44bf1f6e,
    name: "confidentialite"
  }, {
    path: "/ddt-ddtm-dreal",
    component: _1e95aa7b,
    name: "ddt-ddtm-dreal"
  }, {
    path: "/guide",
    component: _2822e858,
    name: "guide"
  }, {
    path: "/login",
    component: _2a4ec5f0,
    name: "login"
  }, {
    path: "/loi-climat-et-resilience",
    component: _758d1a46,
    name: "loi-climat-et-resilience"
  }, {
    path: "/mentions-legales",
    component: _48e90612,
    name: "mentions-legales"
  }, {
    path: "/stats",
    component: _6f34e6be,
    name: "stats"
  }, {
    path: "/validation",
    component: _12e8184d,
    name: "validation"
  }, {
    path: "/dev/api",
    component: _49d0237c,
    name: "dev-api"
  }, {
    path: "/login/collectivites/explain",
    component: _09f64ae4,
    name: "login-collectivites-explain"
  }, {
    path: "/login/collectivites/signin",
    component: _6c077edb,
    name: "login-collectivites-signin"
  }, {
    path: "/login/collectivites/signup",
    component: _fec4555e,
    name: "login-collectivites-signup"
  }, {
    path: "/login/ddt/explain",
    component: _4c9a4292,
    name: "login-ddt-explain"
  }, {
    path: "/login/ddt/signin",
    component: _55e30657,
    name: "login-ddt-signin"
  }, {
    path: "/login/ddt/signup",
    component: _6a795ccd,
    name: "login-ddt-signup"
  }, {
    path: "/",
    component: _73c4fb2e,
    name: "index"
  }, {
    path: "/collectivites/:code_collectivite?",
    component: _601d246e,
    children: [{
      path: "",
      component: _0a068ce8,
      name: "collectivites-code_collectivite"
    }, {
      path: "donnees",
      component: _1c9749a2,
      name: "collectivites-code_collectivite-donnees",
      children: [{
        path: "data",
        component: _13785da7,
        name: "collectivites-code_collectivite-donnees-data"
      }, {
        path: "geoide",
        component: _3fa7c2f6,
        name: "collectivites-code_collectivite-donnees-geoide"
      }, {
        path: "georisques",
        component: _6560458c,
        name: "collectivites-code_collectivite-donnees-georisques"
      }, {
        path: "gpu",
        component: _4d894c3f,
        name: "collectivites-code_collectivite-donnees-gpu"
      }, {
        path: "inpn",
        component: _7719e140,
        name: "collectivites-code_collectivite-donnees-inpn"
      }]
    }, {
      path: "informations",
      component: _8f88b306,
      name: "collectivites-code_collectivite-informations"
    }]
  }, {
    path: "/collectivites/:collectiviteId?",
    component: _31ec53ba,
    name: "collectivites-collectiviteId",
    children: [{
      path: "glossaire",
      component: _9cd51b60,
      name: "collectivites-collectiviteId-glossaire"
    }, {
      path: "pac",
      component: _001d473d,
      name: "collectivites-collectiviteId-pac"
    }, {
      path: "prescriptions",
      component: _18f25af2,
      name: "collectivites-collectiviteId-prescriptions"
    }, {
      path: "ressources",
      component: _241d8d3d,
      name: "collectivites-collectiviteId-ressources"
    }, {
      path: "prescriptions/add",
      component: _072a0616,
      name: "collectivites-collectiviteId-prescriptions-add"
    }, {
      path: "prescriptions/signup",
      component: _34fa2b33,
      name: "collectivites-collectiviteId-prescriptions-signup"
    }, {
      path: "procedures/add",
      component: _1a8bb0b7,
      name: "collectivites-collectiviteId-procedures-add"
    }]
  }, {
    path: "/ddt/:departement?",
    component: _0f405e1f,
    children: [{
      path: "",
      component: _b6a0dd3c,
      name: "ddt-departement"
    }, {
      path: "collectivites",
      component: _14d488fa,
      name: "ddt-departement-collectivites"
    }, {
      path: "enquete",
      component: _7257b4f9,
      name: "ddt-departement-enquete"
    }, {
      path: "pac",
      component: _b428d1bc,
      name: "ddt-departement-pac"
    }, {
      path: "procedures",
      component: _2a9075ba,
      name: "ddt-departement-procedures"
    }, {
      path: "procedures/choix-collectivite",
      component: _45218754,
      name: "ddt-departement-procedures-choix-collectivite"
    }, {
      path: "collectivites/:collectiviteId/commune",
      component: _7d1e2ebf,
      name: "ddt-departement-collectivites-collectiviteId-commune"
    }, {
      path: "collectivites/:collectiviteId/epci",
      component: _af1a2ffc,
      name: "ddt-departement-collectivites-collectiviteId-epci"
    }, {
      path: "collectivites/:collectiviteId/procedure/add",
      component: _86c1fff8,
      name: "ddt-departement-collectivites-collectiviteId-procedure-add"
    }]
  }, {
    path: "/frise/:procedureId",
    component: _5a4ce086,
    name: "frise-procedureId"
  }, {
    path: "/print/:projectId?",
    component: _30f4910b,
    name: "print-projectId"
  }, {
    path: "/trames/:githubRef?",
    component: _f47582b8,
    name: "trames-githubRef"
  }, {
    path: "/documents/:githubRef?/pac",
    component: _ec9d1882,
    name: "documents-githubRef-pac"
  }, {
    path: "/frise/:procedureId?/add",
    component: _17c987d5,
    name: "frise-procedureId-add"
  }, {
    path: "/frise/:procedureId?/invite",
    component: _0cd03a85,
    name: "frise-procedureId-invite"
  }, {
    path: "/frise/:procedureId?/update",
    component: _98793776,
    name: "frise-procedureId-update"
  }, {
    path: "/frise/:procedureId?/:eventId",
    component: _16cad812,
    name: "frise-procedureId-eventId"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
